export const formatSetupFilters = filters => {
  const formattedFilters = {}

  Object.keys(filters).forEach(key => {
    formattedFilters[key] = Array.isArray(filters[key]) ? filters[key].join(',') : filters[key]
  })

  return formattedFilters
}
